import React, { useEffect, useState, useMemo } from 'react'
import Box from '@mui/material/Box'
import { editObject, getObject, addObject } from '../../../api/apiClientCrud'
import useNavigate from '../../hooks/useNavigate'
import { useAuth } from '../../../context/AuthContext'
import { useLocation } from 'react-router-dom'
import Form from '../../form/Form'
import useSaveEntity from '../../hooks/useSaveEntity'
import { getSupplierFields } from './SupplierFields'
import { useFetchEntities } from '../../hooks/useFetchEntities'
import Toolbar from '../../toolbar/Toolbar'

const ROUTES = {
  EDIT: '/suppliers/edit',
  VIEW: '/suppliers/view',
  ADD: '/suppliers/add'
}

const buildPayload = ({ data, user, mode }) => {
  const isEdit = mode === 'edit'
  return {
    ...data,
    ...(isEdit
      ? { lastModBy: user.email }
      : {
          company_id: user.company_id,
          createdBy: user.email
        })
  }
}

const EditSupplier = () => {
  const [supplier, setSupplier] = useState({})
  const [isSubmit, setIsSubmit] = useState(false)

  const history = useNavigate()
  const { user } = useAuth()
  const location = useLocation()

  const path = location.pathname
  const supplierId = location.state?.id

  const mode = useMemo(() => {
    if (path === ROUTES.EDIT) return 'edit'
    if (path === ROUTES.VIEW) return 'view'
    if (path === ROUTES.ADD) return 'add'
    return null
  }, [path])

  const supplierQuery = mode === 'edit' ? { key: 'supplier', fn: getObject, args: ['suppliers', supplierId] } : null

  const queries = [supplierQuery].filter(Boolean)
  const { data: fetched, loading: loadingEntities } = useFetchEntities(queries)

  const { saveEntity, loading } = useSaveEntity({
    entityName: 'suppliers',
    mode,
    id: supplierId,
    user,
    addFn: addObject,
    editFn: editObject,
    updateCounter: false,
    onSuccessRedirect: (id) => history(location.state?.history || ROUTES.VIEW, { state: { id } }),
    onSuccess: () => setIsSubmit(false),
    onError: () => setIsSubmit(false),
    buildPayload
  })

  const options = {
    fields: getSupplierFields(),
    data: supplier,
    location
  }

  const toolbarOptions = useMemo(
    () => ({
      title: () => {
        return path.includes('/add') ? 'Nouveau Fournisseur' : `Fournisseur ${supplier.supplier_name}`
      }
    }),
    [supplier, path]
  )

  useEffect(() => {
    if (!loadingEntities) {
      if (fetched.supplier) setSupplier(fetched.supplier)
    }
  }, [fetched, loadingEntities])

  useEffect(() => {
    if (isSubmit) {
      saveEntity({ data: supplier })
    }
  }, [isSubmit])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 65px)',
        overflowY: 'auto',
        flexBasis: 'auto',
        flexGrow: 1,
        flexShrink: 1
      }}
    >
      <Toolbar options={toolbarOptions} object={supplier} />

      <Form
        mode={mode}
        options={options}
        setDataParent={setSupplier}
        setIsSubmitParent={setIsSubmit}
        loading={loading}
      />
    </Box>
  )
}

export default EditSupplier
